module.exports = __webpack_public_path__ + "img/accessory_shoe_02.f4917d1f.svg";